import axios from 'axios';
import router from "../router";

const state = {
    modules: [],
    moduleData: [],
    formModuleResponses: null

    // events: [],
    // loadEvents: [], // store the new loaded events
    // eventLoadNext: 1,
    // ElementForm: [],
};

const getters = {
    getModules: () => state.modules,
    getModuleData: (state) => (id) => {
        return state.moduleData.find(m => m.ID === id);
    },
    getFormModuleResponses: () => state.formModuleResponses,

    // getEvents: () => state.events,
    // getEventLoadNext: () => state.eventLoadNext,
    // getLoadEvents: () => state.loadEvents,
    // getElementForm: () => state.ElementForm,
};

const actions = {
    /**
     * fetch all modules on this page, we're only fetching the ID and class name of each module on page load to improve page load speed
     * @param commit
     * @returns {Promise<void>}
     */
    async fetchModules({commit}) {
        let pageID = $('#content-modules').data('page-id');
        if (pageID) {
            const response = await axios.get(window.location.origin + '/api/page/' + pageID);
            if (typeof response.data['Modules'] !== 'undefined') {
                commit('updateModules', response.data['Modules']);
            }
        }
    },

    /**
     * each module on created will fetch its own data from the api, each module has a loading state and renders the data when ready
     * @param commit
     * @param id
     * @returns {Promise<void>}
     */
    async fetchModuleData({commit}, id) {
        const response = await axios.get(window.location.origin + '/api/module/' + id);
        if (typeof response.data['ModuleData'] !== 'undefined') {
            let moduleData = response.data['ModuleData'];
            moduleData.ID = id;
            commit('updateModuleData', moduleData);
        }
    },

    /**
     * submits user defined form
     * @param commit
     * @param data
     * @returns {Promise<void>}
     */
    async submitUserForm({commit}, data) {
        const response = await axios.post(window.location.origin + '/forms/submit', data, {headers: {'X-Requested-With': 'XMLHttpRequest'}});
        if (typeof response.data.formID !== 'undefined' && typeof response.data.message !== 'undefined') {
            // let responses = state.formModuleResponses;
            //
            // responses[response.data.formID] = response.data.message;
            commit('updateFormModuleResponses', response.data.message);
        }
    },
    // /**
    //  * handles newsletter submissions sending it to the api
    //  * @param commit
    //  * @param config
    //  */
    // submitNewsletter({commit}, config) {
    //     let url = $('.main').data('url');
    //     axios.post(window.location.origin + url + 'element/' + config.element + '/submit', {
    //         email: config.email,
    //     })
    //         .then(function (data) {
    //
    //         })
    //         .catch(function (error) {
    //             console.log(error);
    //         });
    // }
    //
    // //handle load more event
    // eventLoadMore({commit}, config) {
    //     var url = $('.main').data('url');
    //     axios.post(window.location.origin + url + 'element/' + config.element + '/submit', {
    //         category: config.category,
    //         keyword: config.keyword,
    //         dates: config.dates,
    //         start: config.nextLink
    //     })
    //         .then(function (data) {
    //             if (data.data.process == 'success') {
    //                 let updates = data.data.result['Items'];
    //
    //                 //add new events to list
    //                 updates.forEach(item => {
    //                     list = state.events.push(item);
    //                 })
    //
    //                 let list = state.events;
    //
    //                 commit('updateEvents', list);
    //                 commit('updateEventLoadNext', data.data.result['NextLink']);
    //             }
    //         })
    //         .catch(function (error) {
    //             console.log(error);
    //         });
    // },
    //
    // //handle filter event
    // submitEventFilter({commit}, config) {
    //     var url = $('.main').data('url');
    //     axios.post(window.location.origin + url + 'element/' + config.element + '/submit', {
    //         category: config.category,
    //         keyword: config.keyword,
    //         dates: config.dates,
    //         start: config.nextLink
    //     })
    //         .then(function (data) {
    //             if (data.data.process == 'success') {
    //                 let updates = data.data.result['Items'];
    //
    //                 commit('updateEvents', updates);
    //                 commit('updateEventLoadNext', data.data.result['NextLink']);
    //             }
    //         })
    //         .catch(function (error) {
    //             console.log(error);
    //         });
    // }
};

const mutations = {
    updateModules: (state, value) => (state.modules = value),
    updateModuleData: (state, value) => {
        let module = state.moduleData.find(m => m.ID === value.ID);
        if (typeof module !== 'undefined') {
            module = value;
        } else {
            state.moduleData.push(value);
        }
    },
    updateFormModuleResponses: (state, value) => (state.formModuleResponses = value),

    // updateEvents: (state, value) => (state.events = value),
    // updateLoadEvents: (state, value) => (state.loadEvents = value),
    // updateEventLoadNext: (state, value) => (state.eventLoadNext = value),
    // updateElementForm: (state, value) => (state.ElementForm = value),
};

export default {
    state,
    getters,
    actions,
    mutations
};
